import React from 'react';
import { useI18n } from '../../contexts/I18nContext';

/** The card a list shows while it loads. */
export const ListLoadingCard: React.FC<{ message: string }> = ({ message }) => (
  <div className="tpl-card tpl-state">
    <div className="tpl-spinner" />
    <p>{message}</p>
  </div>
);

/** The card a list shows when its load failed, with a retry. */
export const ListErrorCard: React.FC<{ title: string; message: string; onRetry: () => void }> = ({ title, message, onRetry }) => {
  const { t } = useI18n();
  return (
    <div className="tpl-card tpl-state" role="alert">
      <h3>{title}</h3>
      <p>{message}</p>
      <button type="button" className="btn btn-primary btn-sm" onClick={onRetry}>{t('errors.retryAction')}</button>
    </div>
  );
};

/** The block a table shows under itself when no row matches. */
export const ListEmpty: React.FC<{ title: string; hint?: string; testId?: string; children?: React.ReactNode }> = ({ title, hint, testId, children }) => (
  <div className="tpl-empty" data-testid={testId}>
    <h3>{title}</h3>
    {hint && <p>{hint}</p>}
    {children}
  </div>
);
